import { DataSetDataSet as AgGridJSRowDataSet } from '../Interfaces/Responses/Reports/DataSets/DataSetDataSet';
import AgGridJSRowData from '../Interfaces/Responses/Reports/DataSets/DataSetData';
import DataSetDataResponseModel from '../Interfaces/Responses/Reports/DataSets/DataSetDataResponseModel';

export const dateTimeComparator = (valueA: any, valueB: any) => {
    const timeA = getDateTimeSortValue(valueA);
    const timeB = getDateTimeSortValue(valueB);

    if (timeA === null && timeB === null) return 0;
    if (timeA === null) return -1;
    if (timeB === null) return 1;

    return timeA - timeB;
};

export const isDateColumnFormat = (
    columnName: string,
    datasetColumnFormats: any[]
) => {
    const columnFormat = datasetColumnFormats.find(
        (format: any) => format.columnName === columnName
    );

    return columnFormat?.jsDataType === 'date';
};

const getDateTimeSortValue = (value: any): number | null => {
    if (value === null || value === undefined || value === '') return null;

    const parsed = Date.parse(value.toString());

    return Number.isNaN(parsed) ? null : parsed;
};

export const transformServaGridToAgGridJSGrid = (
    servaGrid: DataSetDataResponseModel,
    title: string
): AgGridJSRowData => {
    let labels = undefined;

    // ---- DEBUG
    // console.log("**** servaGrid ****");
    // console.log(servaGrid);
    // ---- END DEBUG

    const dataSets: AgGridJSRowDataSet[] = [];
    
    for (var i = 0; i < servaGrid.data.length; ++i) {
        const agGridJSRowDataSet: AgGridJSRowDataSet = {
            drilldowns: servaGrid.drilldowns,
            drilldownDataSetInputId: 
                servaGrid.drilldowns?.length > 0
                    ? servaGrid.drilldowns[0].targetDataSetID
                    : 0,
            drilldownDataSetChartId:
                servaGrid.drilldowns?.length > 0
                    ? servaGrid.drilldowns[0].targetChartID
                    : 0,
            drilldownTenantId:
                servaGrid.drilldowns?.length > 0
                    ? servaGrid.drilldowns[0].tenantID
                    : 0,
            data: servaGrid.data[i],
        };

        dataSets.push(agGridJSRowDataSet);
    };
    
    labels = servaGrid.columns.map(
        (eachColumn) => {return eachColumn.name});

    const rawVals: string[] = [];

    for (var j = 0; j < servaGrid.data.length; ++j) {
        const rawVal = servaGrid.drilldowns?.length > 0
            ? servaGrid.data[j][servaGrid.drilldowns[0].sourceColumn]
            : 0;

        rawVals.push(rawVal);
    }
    
    /*rawVals = servaGrid.columns.map(
        (eachColumn) => {return ""});*/

    // ---- DEBUG
    // console.log("**** dataSets ****");
    // console.log(dataSets);
    // console.log("**** labels ****");
    // console.log(labels);
    // console.log("**** rawVals ****");
    // console.log(rawVals);
    // ---- END DEBUG
    
    return {
        labels,
        rawVals,
        dataSets,
        title,
    };
}

